export const headers = {
  opportunity: "Opportunity",
  statusName: "Approval Status",
  totalHeadCount: "Headcount",
  productName: "Product",
  productVariationName: "Product variation",
  pricingStructureName: "Pricing Structure",
  blendedRateReqCurrency: "Rate (requested currency)",
  blendedRateUSD: "Rate(USD)",
  blank1: "Total",
  totalAnnualRevenueReqCurrency: "Total revenue - incl. commission",
  totalAnnualRevenueUSD: "USD Total revenue - incl. commission",
  productAsssumptions: "Product Assumptions",
  sessions: "Session model",
  utilization: "Utilization",
  hours: "Hours",
  seatCount: "Seats",
  programStartDate: "Program Start date",
  tcvcad: "TCV (CAD)",
};
export const oppurtunityHeaders = {
  opportunity: "Opportunity",
  statusName: "Approval Status",
  totalHeadCount: "Headcount",
  productName: "Product",
  productVariationName: "Product variation",
  pricingStructureName: "Pricing Structure",
  blendedRateReqCurrency: "Rate (requested currency)",
  blendedRateUSD: "Rate(USD)",
  tcvcad: "TCV (CAD)",
};
export const oppurtunityHeader = {
  opportunity: "Opportunity",}
export const totalHeaders = {
blank1: "Total",
  totalAnnualRevenueReqCurrency: "Total revenue - incl. commission",
  totalAnnualRevenueUSD: "USD Total revenue - incl. commission",
};
export const totalHeader = {
  blank1: "Total",};
export const ProductHeaders = {
  productAsssumptions: "Product Assumptions",
  sessions: "Session model",
  utilization: "Utilization",
  hours: "Hours",
  seatCount: "Seats",
  programStartDate: "Program Start date",};
  export const ProductHeader = {
    productAsssumptions: "Product Assumptions",
  };
export const statusColors = {
  "Quote Pending SAM Leadership": "#8A9123",
  "Quote Pending Pricing Team": "#8A9123",
  "Quote closed": "#C81E1E",
  "Quote Approved": "#00AF97",
  "Quote Submitted": "#239155",
  Contracted: "#91238D",
  "Save as draft": "#229353",
  "Closed without approval": "#2eb71e",
  "Quote Pending \nInitial Requestor": "#E27900",

  // Add more status values and colors as needed
};
export const noteHeader = ["No.", "With whom", "Date", "Time", "Message"];
export const currentQuoteKeys = {
  productName: "Product",
  opportunityName: "Opportunity Name",
  rate: "Rate (In Requested Currency)",
  currencyName: "Currency",
  rateInUSD: "Rate (In USD)",
  pricingStructure: "Pricing Structure",
  session: "Session",
  hours: "Hours",
  utilization: "Utilization (%)",
  headCount: "Headcount",
  startDate: "Start Date",
};

export const accountData = {
  accountName: "Test account",
  totalHeadcount: "5000",
  brokerName: "",
  brokerCommission: "0%",
};
export const actionHeaders = {
  viewQuote: "View quote",
  approve: "Approve",
  SAMRecomm: "SAM Recomm.",
  notes: "Notes",
};

export const quoteHeaders = {
  action: "",
  quoteName: "Quote Name",
  statusName: "Status",
  productName: "Product",
  productVariationName: "Product variation",
  rateReqCurrency: "Rate (in Requested Currency)",
  currencyCode: "Currency",
  rateUSD: "Rate (in USD)",
  tcvcad: "TCV (CAD)",
  pricingStructureName: "Pricing Structure",
  sessions: "Session",
  hours: "Hours",
  utilization: "Utilization (%)",
  headCount: "Headcount",
};

export const currentQuoteHeaders = [
  "Products",
  "Opp. Name",
  "Rate (in Opp Currency)",
  "Currency",
  "Rate (in opp USD)",
  "Pricing Structure",
  "Session",
  "Hours",
  "Utilization (%)",
  "Headcount",
  "Start Date",
];

export const CurrentToolTip = (
  <div>
    Quotes are filtered by following criteria from Dynamics
    <p>
      <ul style={{ listStyleType: "none" }}>
        <li>
          <b>1. </b>Opportunity Status = "Won"{" "}
        </li>
        <li>
          <b>2. </b>Opportunity Sales Stage= "Program Live"
        </li>
        <li>
          <b>3. </b>Opportunity Product Termination Date is null{" "}
        </li>
        <li>
          <b>4. </b>Opportunity Product/ Quote Status="Won"{" "}
        </li>
      </ul>
    </p>
  </div>
);

export const BundleToolTip = (
  <div>This section shows all bundles created using the Quoted Section.</div>
);

export const QuotedToolTip = (
  <div>
    This section shows all the quotes available under the selected opportunity
    (Same as in landing page)
  </div>
);

export const currentQuotesData = [
  {
    oppurtunityId: "4b32ff2f-c552-ee11-be6f-0022482a90a6",
    oppurtunity: "OP-004513",
    oppurtunityName: "Test-CPQ-OPR",
    brokerName: "TestCPQ",
    accountName: "TestCPQ",
    quoteId: "a8c66519-28d1-497e-a5a4-0008c1d95d6a",
    quoteName: "Q-20240103-12",
    accountId: "",
    oppurtunityType: "NEW",
    member: "",
    referrerName: "",
    commission: 0.0,
    percentagePaid: 0.0,
    discount: 0.0,
    currencyId: 16,
    currencyName: "US Dollar",
    currencyCode: "USD",
    noOfLivesSavedByPartner: "",
    totalPotentialHeadCountOutside: 4,
    formalRFPNotes: "",
    competitorsBidders: "",
    pastQuotes: "5",
    currentUtilizationWithOtherVendors: "4",
    deadline: "2024-01-19T00:00:00",
    noOfRAMs: 4,
    locationRAMs: "",
    samPriceRecommendAssumption: "4",
    productId: 2,
    productName: "Total Source",
    productVariationId: 0,
    productVariationName: null,
    sessions: null,
    utilization: null,
    pricingStructureId: 3,
    pricingStructureName: "Flat Fee - Monthly",
    quoteStatusId: 2,
    statusName: "Quote Pending Pricing Team",
    accountManagerName: "",
    amHours: 0.0,
    existingPartneredClientInfo: "",
    currentRateEffectiveOn: "",
    pastThreeYrRateHeadCount: "",
    estimatedNoOfAMHrPerYear: "",
    annualUtilizationThreeYrs: "",
    hours: 0.0,
    additionalNotes: "ee",
    companyId: 1,
    createdBy: 1,
    createdDate: "2024-01-03T11:00:30.3",
    lastModifiedBy: 1,
    lastModifiedDate: "2024-01-03T11:13:45.76",
    isActive: true,
    id: 1,
    totalHeadCount: 21500,
    blendedRateReqCurrency: 0,
    totalAnnualRevenue: 0,
  },
];
